/** Calendar texts (plan 2.4 "Agenda"). Dutch first, informal "je". */
export const calendarNl = {
  'cal.today': 'Vandaag',
  'waitlist.chip': 'Wachtlijst · {n}',
  'waitlist.title': 'Wachtlijst',
  'waitlist.intro': 'Zij willen graag op deze dag komen. Valt er iets vrij dat past, dan krijgen ze automatisch een mail. Je kunt ze ook zelf bellen.',
  'waitlist.empty': 'Niemand op de wachtlijst voor deze dag.',
  'waitlist.part.morning': 'Ochtend',
  'waitlist.part.afternoon': 'Middag',
  'waitlist.part.evening': 'Avond',
  'waitlist.part.any': 'Hele dag',
  'waitlist.waiting': 'Wacht op een plek',
  'waitlist.mailed': 'Gemaild om {time} dat er plek is',
  'waitlist.remove': 'Haal eraf',
  'cal.prev': 'Vorige',
  'cal.next': 'Volgende',
  'cal.pickDate': 'Kies een datum',
  'cal.view.day': 'Dag',
  'cal.view.week': 'Week',
  'cal.view.list': 'Lijst',
  'cal.everyone': 'Iedereen',
  'cal.jump': 'Over … weken',
  'cal.jumpWeeks': 'Over {n} weken',
  'cal.jumpWeek': 'Over 1 week',
  'cal.newAppointment': 'Nieuwe afspraak',
  'cal.closed': 'Gesloten',
  'cal.notWorking': 'Werkt niet',
  'cal.nobodyWorking': 'Vandaag werkt er niemand volgens de openingstijden en werktijden.',
  'cal.noTeam': 'Voeg eerst je team toe bij Salon → Team.',
  'cal.noLocation': 'Je salon heeft nog geen locatie.',
  'cal.noClient': 'Zonder klant',
  'cal.walkIn': 'Inloop',
  'cal.online': 'Online geboekt',
  'cal.newClient': 'Nieuwe klant',
  'cal.alert': 'Let op',
  'cal.requested': 'Klant koos deze medewerker',
  'cal.listEmpty': 'Geen afspraken op deze dag.',
  'cal.switchPerson': 'Wissel van medewerker',
  'cal.swipeHint': 'Veeg om van dag te wisselen',
  'cal.loading': 'Agenda laden…',
  'welcome.title': 'Je salon klaarzetten',
  'welcome.progress': 'Stap {n} van {total}',
  'welcome.step.salon': 'Je salon',
  'welcome.step.hours': 'Openingstijden',
  'welcome.step.services': 'Diensten',
  'welcome.step.team': 'Team',
  'welcome.hint.salon': 'Adres en telefoon, zodat klanten je vinden.',
  'welcome.hint.hours': 'Wanneer klanten online kunnen boeken.',
  'welcome.hint.services': 'Wat je doet, hoe lang het duurt en wat het kost.',
  'welcome.hint.team': 'Wie er bij je werkt, of alleen jij.',
  'welcome.hint.live': 'Je boekingspagina staat live',
  'welcome.later': 'Ongeveer 5 minuten. Alles kun je later in Salon aanpassen.',
  'welcome.next': 'Verder',
  'welcome.preview.title': 'Zo zien klanten je boekingspagina',
  'welcome.preview.label': 'Online boeken',
  'welcome.preview.choose': 'Kies een dienst',
  'welcome.preview.team': 'Boeken bij jou en',
  'welcome.preview.bar': '1 dienst · 45 min',
  'welcome.preview.next': 'Kies een tijd',
  'welcome.back': 'Terug',
  'welcome.salon.title': 'Waar zit je salon?',
  'welcome.salon.intro': 'Klanten zien je adres op je boekingspagina en in de bevestiging. Postcode en huisnummer zijn genoeg.',
  'welcome.salon.phone': 'Telefoonnummer van de salon',
  'welcome.salon.phoneHint': 'Voor klanten die willen bellen of appen.',
  'welcome.hours.title': 'Wanneer ben je open?',
  'welcome.hours.intro': 'We hebben een gebruikelijk patroon ingevuld. Pas aan wat niet klopt; feestdagen en vrije dagen regel je later.',
  'welcome.services.title': 'Wat kunnen klanten boeken?',
  'welcome.services.intro': 'Een start voor je soort zaak. Zet je eigen prijzen erbij en haal weg wat je niet doet.',
  'welcome.services.price': 'Prijs',
  'welcome.services.keep': 'Toch houden',
  'welcome.services.later': 'Duur, varianten en inwerktijd pas je later aan onder Salon → Diensten.',
  'welcome.team.title': 'Werk je alleen?',
  'welcome.team.intro': 'Elke collega krijgt een eigen kolom in de agenda. Inloggen voor collega’s kan later.',
  'welcome.team.alone': 'Ik werk alleen',
  'welcome.team.more': 'We zijn met meer',
  'welcome.team.name': 'Naam collega {n}',
  'welcome.team.add': 'Nog iemand',
  'welcome.team.inviteLater': 'Uitnodigen om in te loggen doe je later bij Salon → Team.',
  'welcome.live.title': 'Je boekingspagina staat live',
  'welcome.live.intro': 'Klanten kunnen nu zelf boeken. Deel je link of laat de QR-code zien.',
  'welcome.live.instagram': 'Tip: zet de link in je Instagram-bio en je Google-bedrijfsprofiel. Daar zoeken klanten het eerst.',
  'welcome.live.done': 'Naar Vandaag',
  'welcome.live.website': 'Knop voor je website',
  'loc.current': 'Locatie',
  'loc.title': 'Locaties',
  'loc.intro': 'Elke locatie heeft eigen openingstijden, een eigen team en een eigen boekingslink. Klanten zijn gedeeld.',
  'loc.add': 'Locatie toevoegen',
  'loc.addSecond': 'Tweede locatie toevoegen',
  'loc.addSecondHint': 'Heb je meer dan één zaak? Voeg een locatie toe met eigen openingstijden en team.',
  'loc.new': 'Nieuwe locatie',
  'loc.name': 'Naam van de locatie',
  'loc.nameHint': 'Zo zien klanten hem, bijvoorbeeld "Centrum" of "Utrecht".',
  'loc.phone': 'Telefoonnummer',
  'loc.street': 'Straat',
  'loc.houseNumber': 'Huisnummer',
  'loc.postcode': 'Postcode',
  'loc.city': 'Plaats',
  'loc.archive': 'Locatie verwijderen',
  'loc.archiveConfirm': 'Deze locatie verdwijnt uit de agenda en van de boekingspagina. Afspraken uit het verleden blijven bewaard.',
  'loc.hoursHint': 'Openingstijden stel je per locatie in onder Openingstijden; kies de locatie linksboven.',
  'loc.where': 'Werkt op',
  'loc.everywhere': 'Alle locaties',
  'loc.bookingLinks': 'Een link per locatie',
  'msg.title': 'Berichten',
  'msg.intro': 'Wat je klanten en je team automatisch krijgen. Alles staat standaard goed; pas aan wat je wilt.',
  'msg.whatsapp': 'Berichten aan klanten via WhatsApp',
  'msg.group.after': 'Na het bezoek',
  'msg.review': 'Vraag om een review',
  'msg.review.hint': 'Eén e-mail na een afgeronde afspraak met een link naar je reviewpagina. Hooguit eens per 90 dagen per klant, nooit na een no-show of annulering. Klanten kunnen zich met één klik afmelden.',
  'msg.review.url': 'Link naar je reviewpagina',
  'msg.review.urlHint': 'Bijvoorbeeld je Google-bedrijfsprofiel: Reviews → "Reviews vragen" → kopieer de link.',
  'msg.review.when': 'Wanneer',
  'msg.review.after3': 'Een paar uur na de afspraak',
  'msg.review.after24': 'De dag erna',
  'msg.review.needUrl': 'Plak eerst de link naar je reviewpagina.',
  'msg.review_request': 'Review-verzoek',
  'msg.rebook': 'Herinnering nieuwe afspraak',
  'clients.remind': 'Stuur herinnering',
  'clients.reminded': 'Herinnering verstuurd',
  'clients.remindHint': 'Een e-mail met een link om een nieuwe afspraak te maken, met de vaste behandeling al gekozen.',
  'msg.whatsapp.hint': 'Bevestigingen, herinneringen en wijzigingen gaan via WhatsApp naar klanten met een mobiel nummer. Lukt dat niet, dan krijgen ze een e-mail.',
  'msg.group.booking': 'Bij het boeken',
  'msg.group.before': 'Voor de afspraak',
  'msg.group.change': 'Bij een wijziging',
  'msg.group.team': 'Voor je team',
  'msg.confirmation': 'Bevestiging',
  'msg.confirmation.hint': 'Direct na het boeken, met een link om te wijzigen of te annuleren.',
  'msg.reminder': 'Herinnering',
  'msg.reminder.hint': 'Niet als de afspraak binnen die tijd geboekt is.',
  'msg.changed': 'Afspraak gewijzigd',
  'msg.changed.hint': 'Twee minuten na een wijziging, zodat verplaatsen en ongedaan maken geen dubbele berichten geeft.',
  'msg.cancelled': 'Afspraak geannuleerd',
  'msg.cancelled.hint': 'Als jij of de klant annuleert.',
  'msg.team_booked': 'Nieuwe online boeking',
  'msg.team_booked.hint': 'Naar het e-mailadres van de salon (Bedrijfsgegevens), of anders naar de eigenaar.',
  'msg.team_cancelled': 'Online geannuleerd',
  'msg.team_cancelled.hint': 'Als een klant zelf annuleert.',
  'msg.email': 'E-mail',
  'msg.timing': 'Wanneer',
  'msg.hoursBefore': '{n} uur van tevoren',
  'msg.addText': 'Eigen tekst toevoegen',
  'msg.editText': 'Tekst aanpassen',
  'msg.ownText': 'Je eigen tekst',
  'msg.ownTextPlaceholder': 'Bijvoorbeeld: Kom je 5 minuten eerder? Parkeren kan gratis achter de salon.',
  'msg.ownTextHint': 'Komt onder de vaste tekst. Datum, tijd en de link om te wijzigen staan er altijd in.',
  'msg.preview': 'Voorbeeld',
  'msg.sendTest': 'Stuur mij een test',
  'msg.testSent': 'Verstuurd naar {email}',
  'msg.later': 'SMS en WhatsApp komen later. Berichten zonder reclame mag je altijd sturen; daar is geen toestemming voor nodig.',
  'feed.title': 'Agenda in de telefoon',
  'feed.titleOwn': 'Je afspraken in je eigen agenda',
  'feed.intro': 'Zie de afspraken in Google Agenda, Apple Agenda of Outlook. Alleen lezen; wijzigingen komen binnen ongeveer 15 minuten door.',
  'feed.apple': 'Apple Agenda / Outlook',
  'feed.google': 'Google Agenda',
  'feed.copy': 'Link kopiëren',
  'feed.private': 'Deze link is privé: iedereen met de link ziet deze afspraken.',
  'feed.renew': 'Nieuwe link maken',
  'feed.renewConfirm': 'De oude link stopt dan met werken. Agenda’s die hem gebruiken moet je opnieuw toevoegen.',
  'sort.move': 'Verplaatsen',
  'sort.hint': 'Sleep om de volgorde te wijzigen (of gebruik de pijltjestoetsen)',
  'access.title': 'App-toegang',
  'access.intro': 'Optioneel: met een eigen login ziet dit teamlid de agenda op de eigen telefoon.',
  'access.email': 'E-mailadres',
  'access.role': 'Rol',
  'access.staffHint': 'Medewerker: Vandaag, Agenda en Klanten. Instellingen van de salon niet.',
  'access.managerHint': 'Manager: alles behalve het abonnement.',
  'access.send': 'Uitnodiging sturen',
  'access.invited': 'Uitgenodigd: {email}',
  'access.invitedShort': 'Uitgenodigd',
  'access.resend': 'Opnieuw sturen',
  'access.resent': 'Verstuurd',
  'access.otherEmail': 'Ander e-mailadres',
  'access.withdraw': 'Intrekken',
  'access.makeManager': 'Maak manager',
  'access.makeStaff': 'Maak medewerker',
  'access.remove': 'Toegang intrekken',
  'access.removeConfirm': '{name} kan dan niet meer inloggen. De agenda en afspraken blijven staan.',
  'booking.title': 'Online boeken',
  'booking.intro': 'Klanten boeken zelf via je boekingslink of de knop op je website. Je ziet het meteen in de agenda.',
  'booking.link': 'Je boekingslink',
  'booking.linkIntro': 'Deel deze link of QR-code. Iedereen kan er direct mee boeken.',
  'booking.linkWhere': 'Zet hem in je Instagram-bio, je WhatsApp-status, je Google-bedrijfsprofiel en op je website.',
  'booking.share': 'Deel je boekingslink',
  'booking.shareTitle': 'Maak online een afspraak',
  'booking.copied': 'Gekopieerd',
  'booking.copy': 'Kopiëren',
  'booking.open': 'Bekijk als klant',
  'booking.qrAlt': 'QR-code van je boekingslink',
  'booking.qrDownload': 'QR-code downloaden',
  'booking.website': 'Op je website',
  'booking.websiteIntro': 'Plak een van deze regels in je website (WordPress, Wix of gewone HTML).',
  'booking.websiteButton': 'Zwevende knop "Afspraak maken"',
  'booking.websiteInline': 'Boeken in de pagina zelf',
  'booking.rules': 'Regels',
  'booking.enabled': 'Online boeken aan',
  'booking.enabledHint': 'Uit: je boekingspagina toont je telefoonnummer in plaats van tijden.',
  'booking.lead': 'Minimaal van tevoren boeken',
  'booking.leadNone': 'Geen minimum',
  'booking.ahead': 'Hoe ver vooruit',
  'booking.step': 'Starttijden',
  'booking.stepHint': 'Klanten kunnen alleen op deze tijden beginnen.',
  'booking.every': 'Elke {n} minuten',
  'booking.change': 'Online verzetten tot',
  'booking.changeHint': 'Annuleren kan altijd; binnen deze tijd telt het als laat geannuleerd.',
  'booking.changeAlways': 'Altijd',
  'booking.hoursBefore': '{n} uur van tevoren',
  'booking.hours': '{n} uur',
  'booking.days': '{n} dag(en)',
  'booking.weeks': '{n} weken',
  'booking.months': '{n} maand(en)',
  'booking.year': '1 jaar',
  'booking.staffChoice': 'Klant kiest medewerker',
  'booking.staffChoiceHint': 'Uit: klanten kiezen alleen een tijd, jij verdeelt het werk eerlijk.',
  'booking.emailRequired': 'E-mailadres verplicht',
  'booking.emailRequiredHint': 'Nodig voor de bevestiging en de herinnering.',
  'booking.waitlist': 'Wachtlijst',
  'booking.waitlistHint': 'Is een dag vol, dan kunnen klanten zich aanmelden. Valt er een afspraak af, dan krijgen ze meteen een mail.',
  'today.inAgenda': 'Vandaag in de agenda',
  'today.occupancy': 'Bezetting',
  'today.sum.one': 'Nog 1 afspraak vandaag.',
  'today.sum.many': 'Nog {n} afspraken vandaag.',
  'today.setup.progress': '{done} van {total} klaar',
  'today.openClient': 'Open klant',
  'tag.new': 'Nieuw',
  'tag.online': 'Online',
  'today.hero.empty': 'Nog niets in de agenda vandaag. Deel je boekingslink, dan boeken klanten zelf.',
  'today.hero.next': 'Volgende: {time} {name}, bij {who}.',
  'today.hero.done': 'De laatste afspraak van vandaag is geweest.',
  'today.hero.ofTotal': 'van de {n} vandaag',
  'today.occToday': 'Vandaag',
  'today.occWeek': 'Deze week',
  'today.occClosed': 'Niemand ingeroosterd',
  'today.newClients': 'Nieuwe klanten vandaag',
  'today.returningClients': 'Vaste klanten vandaag',
  'today.since': 'Nieuw sinds je laatste bezoek',
  'today.act.created': 'Online geboekt',
  'today.act.cancelled': 'Geannuleerd door klant',
  'today.act.moved': 'Verzet door klant',
  'today.todo': 'Te doen',
  'today.undelivered': 'Bericht niet aangekomen bij {name}',
  'today.undeliveredHint': 'Klopt het e-mailadres? Open de klant en pas het aan.',
  'today.someone': 'een klant',
  'switches.title': 'Wat medewerkers kunnen',
  'switches.intro': 'Geldt voor iedereen met de rol Medewerker. Managers en de eigenaar kunnen altijd alles.',
  'switches.allAgendas': 'Agenda van collega’s zien',
  'switches.allAgendasHint': 'Uit: een medewerker ziet alleen de eigen kolom.',
  'switches.contact': 'Telefoon en e-mail van klanten zien',
  'switches.contactHint': 'Uit: de naam en notities blijven zichtbaar, contactgegevens niet.',
  'switches.editOthers': 'Afspraken van collega’s wijzigen',
  'switches.editOthersHint': 'Aan: een medewerker kan ook afspraken van anderen verzetten of annuleren.',
  'clients.export': 'Exporteren',
  'import.button': 'Importeren',
  'import.title': 'Klanten importeren',
  'import.intro': 'Exporteer je klanten als CSV-bestand uit Salonized, Treatwell, Fresha of een spreadsheet, en kies het bestand hier. Er gebeurt nog niets tot je op importeren drukt.',
  'import.file': 'Kies een CSV-bestand',
  'import.reading': 'Bestand lezen…',
  'import.columns': 'Welke kolom is wat?',
  'import.columnsHint': 'We hebben de kolommen herkend. Klopt iets niet, kies dan de goede kolom.',
  'import.field.firstName': 'Voornaam',
  'import.field.lastName': 'Achternaam',
  'import.field.fullName': 'Volledige naam',
  'import.field.phone': 'Mobiel nummer',
  'import.field.email': 'E-mailadres',
  'import.field.notes': 'Notities',
  'import.unused': '— niet gebruiken',
  'import.summary': '{create} nieuwe klanten',
  'import.existing': '{n} staan al in je klantenlijst (zelfde nummer of e-mail)',
  'import.duplicate': '{n} dubbel in het bestand',
  'import.invalid': '{n} regels zonder naam worden overgeslagen',
  'import.existingChoice': 'Klanten die je al hebt',
  'import.skip': 'Overslaan',
  'import.fill': 'Lege gegevens aanvullen (nummer, e-mail, achternaam, notities)',
  'import.sample': 'Zo komen ze binnen',
  'import.problems': 'Let op in het bestand',
  'import.line': 'Regel {n}',
  'import.reason.no_name': 'geen naam, overgeslagen',
  'import.reason.phone': 'telefoonnummer onleesbaar, zonder nummer geïmporteerd',
  'import.reason.email': 'e-mailadres onleesbaar, zonder e-mail geïmporteerd',
  'import.reason.phone,email': 'telefoon en e-mail onleesbaar',
  'import.status.create': 'nieuw',
  'import.status.existing': 'bestaat al',
  'import.status.duplicate': 'dubbel',
  'import.run': '{n} klanten importeren',
  'import.done': '{created} klanten toegevoegd',
  'import.filled': '{n} bestaande klanten aangevuld',
  'import.undo': 'Ongedaan maken',
  'import.undone': '{n} klanten weer verwijderd',
  'import.kept': '{n} hadden al een afspraak en zijn gebleven',
  'import.finish': 'Klaar',
  'import.another': 'Ander bestand kiezen',
  'clients.since': 'Klant sinds {date}',
  'clients.lateCancels': '{n} keer laat geannuleerd',
  'clients.blocked': 'Geblokkeerd voor online boeken',
  'clients.messages': 'Verstuurde berichten',
  'clients.msgSent': 'Verstuurd',
  'clients.msgFailed': 'Niet aangekomen',
  'clients.blockLabel': 'Blokkeren voor online boeken',
  'clients.blockHint': 'Deze klant ziet dan "bel of app de salon" (herkend aan telefoon en e-mail). In de agenda kun je nog wel boeken.',
  'clients.anonymise': 'Klantgegevens verwijderen (AVG)',
  'clients.anonymiseConfirm': 'De naam en contactgegevens van {name} worden verwijderd. Afspraken blijven anoniem staan voor je cijfers. Dit kan niet ongedaan worden.',
  'clients.alertAdd': 'Toevoegen',
  'clients.alertNone': 'Bijvoorbeeld een allergie. Zichtbaar in de agenda (⚠), nooit in berichten aan de klant.',
  'clients.alertPlaceholder': 'Bijvoorbeeld: allergisch voor latex',
  'clients.health': 'Dit gaat over gezondheid (allergie, medisch)',
  'clients.healthHint': 'Gezondheidsinformatie mag je alleen bewaren met toestemming van de klant.',
  'clients.consent': 'De klant heeft toestemming gegeven om dit te bewaren (bij jonger dan 16: een ouder).',
  'clients.consentGiven': 'Opgeslagen met toestemming van de klant.',
  'clients.withdraw': 'Toestemming ingetrokken',
  'clients.withdrawConfirm': 'De notitie wordt dan verwijderd.',
  'clients.name': 'Naam',
  'clients.lastVisit': 'Laatste bezoek',
  'clients.nextVisit': 'Volgende afspraak',
  'clients.visits': 'Bezoeken',
  'clients.book': 'Afspraak maken',
  'clients.history': 'Afspraken',
  'clients.noAppointments': 'Nog geen afspraken.',
  'clients.notes': 'Notities',
  'clients.group.all': 'Iedereen',
  'clients.group.upcoming': 'Komen terug',
  'clients.group.away': 'Lang niet geweest',
  'clients.group.new': 'Nieuw',
  'clients.groupHint.upcoming': 'Hebben een afspraak staan, eerstvolgende bovenaan.',
  'clients.groupHint.away': 'Langer dan 8 weken niet geweest en niets gepland. Tijd om even te bellen of appen?',
  'clients.groupHint.new': 'In de laatste 30 dagen voor het eerst in je klantenlijst gekomen.',
  'clients.groupEmpty': 'Niemand in deze groep.',
  'clients.more': 'Meer laden',
  'clients.shown': '{n} van {total}',
  'clients.pickTitle': 'Kies een klant',
  'clients.pickBody': 'Klik op een naam en de klantkaart opent hier: afspraken, notities en wat we stuurden.',
  'clients.callBack': 'Even bellen?',
  'clients.callBackBody': 'Al een tijd niet geweest en niets gepland.',
  'clients.weeksAgo': '{n} weken geleden',
  'clients.visitsN': '{n} bezoeken',
  'clients.overview': 'Je klantenbestand',
  'clients.rebooked': 'heeft al een volgende afspraak staan',
  'clients.nothingPlanned': 'Nog niets gepland',
  'clients.seeAll': 'Bekijk alle {n}',
  'cal.side.day': 'Deze dag',
  'cal.side.week': 'Deze week',
  'cal.side.appointments': 'Afspraken',
  'cal.side.newClients': 'Nieuwe klanten',
  'cal.side.online': 'Online geboekt',
  'cal.side.revenue': 'Verwachte omzet',
  'cal.side.free': 'Nog vrij',
  'cal.side.freeHint': 'Plekken van een half uur of langer. Klik om er een afspraak in te zetten.',
  'cal.side.full': 'Vol',
  'cal.side.dayOver': 'Werkdag voorbij',
  'cal.side.prevMonth': 'Vorige maand',
  'cal.side.nextMonth': 'Volgende maand',
  'cal.side.hours': '{h} u',
  'cal.side.hoursMinutes': '{h} u {m} min',
  'cal.side.minutes': '{m} min',
  'today.working': 'Wie werkt er vandaag',
  'close.eyebrow': 'Einde van de dag',
  'close.title': 'Dag afsluiten',
  'close.intro': 'In een minuut: wie er niet kwam, wie nog geen volgende afspraak heeft, en morgen.',
  'close.start': 'Dag afsluiten',
  'close.done': 'Dag afgesloten',
  'close.noShows': 'Niet gekomen?',
  'close.noShowsHint': 'Wat je niet aanwijst, telt vanzelf als geweest.',
  'close.markNoShow': 'Niet gekomen',
  'close.noVisits': 'Er waren vandaag geen afspraken.',
  'close.withoutNext': 'Nog geen volgende afspraak',
  'close.withoutNextHint': 'Plan de volgende nu, nu ze nog vers in je hoofd zitten.',
  'close.planNext': 'Plan volgende',
  'close.allPlanned': 'Iedereen van vandaag heeft al een volgende afspraak.',
  'close.tomorrow': 'Morgen',
  'close.tomorrowCount': '{n} afspraken, de eerste om {time}',
  'close.tomorrowOne': '1 afspraak, om {time}',
  'close.tomorrowNone': 'Morgen staat er nog niets.',
  'close.alert': 'Let op bij {name} ({time})',
  'close.newClient': 'Nieuw: {name} ({time})',
  'close.finish': 'Klaar',
  'close.stillToCome': 'Er komen vandaag nog {n} afspraken.',
  'today.stat.appointments': 'Afspraken',
  'today.stat.toGo': 'nog {n} te gaan',
  'today.stat.allDone': 'allemaal geweest',
  'today.stat.occupancy': 'Bezetting',
  'today.stat.week': 'deze week {pct}',
  'today.stat.revenue': 'Verwachte omzet',
  'today.stat.revenueHint': 'zonder no-shows',
  'today.stat.clients': 'Vaste klanten',
  'today.stat.new': '{n} nieuw',
  'today.next': 'Volgende klant',
  'today.now.label': 'Nu bezig',
  'today.tomorrow': 'Morgen als eerste',
  'today.until': 'tot {time}',
  'today.with': 'bij {name}',
  'today.firstVisit': 'Eerste bezoek',
  'today.openInAgenda': 'Open in agenda',
  'today.col.time': 'Tijd',
  'today.col.client': 'Klant',
  'today.col.service': 'Dienst',
  'today.col.who': 'Bij',
  'today.col.price': 'Prijs',
  'today.nobody': 'Vandaag werkt er niemand.',
  'today.appointments': '{n} afspraken',
  'today.oneAppointment': '1 afspraak',
  'today.now': 'nu',
  'status.completed': 'Afgerond',
  'status.no_show': 'No-show',
  'status.cancelled': 'Geannuleerd',
  'status.requested': 'Aanvraag',
  'status.client_confirmed': 'Bevestigd door klant',
  'status.booked': 'Geboekt',

  'appt.tab.appointment': 'Afspraak',
  'appt.tab.block': 'Tijd blokkeren',
  'appt.client': 'Klant',
  'appt.searchClient': 'Zoek op naam of telefoon',
  'appt.newClient': 'Nieuwe klant',
  'appt.firstName': 'Voornaam',
  'appt.lastName': 'Achternaam',
  'appt.phone': 'Mobiel nummer',
  'appt.emailOptional': 'E-mailadres (voor bevestiging en herinnering)',
  'appt.notify': 'Stuur bevestiging naar klant',
  'appt.notifyHint': 'Per e-mail naar {email}, met een herinnering een dag van tevoren.',
  'appt.notifyChange': 'Klant informeren over de wijziging',
  'appt.notifyChangeHint': 'De klant krijgt na twee minuten één bericht met de nieuwe tijd.',
  'toast.dontNotify': 'Klant niet informeren',
  'toast.notNotified': 'De klant krijgt geen bericht',
  'appt.noResults': 'Geen klant gevonden.',
  'appt.change': 'Wijzig',
  'appt.removeClient': 'Zonder klant',
  'appt.services': 'Dienst',
  'appt.addService': '+ Nog een dienst',
  'appt.chooseService': 'Kies een dienst',
  'appt.noServices': 'Je hebt nog geen diensten.',
  'appt.addServices': 'Diensten toevoegen',
  'appt.chooseVariant': 'Kies een variant',
  'appt.staff': 'Medewerker',
  'appt.noPreference': 'Geen voorkeur',
  'appt.date': 'Datum',
  'appt.time': 'Tijd',
  'appt.now': 'Nu (inloop)',
  'appt.findFree': 'Vind vrije tijd',
  'appt.freeTimes': 'Eerstvolgende vrije tijden',
  'appt.noFreeTimes': 'Geen vrije tijd gevonden in de komende drie maanden.',
  'appt.note': 'Notitie',
  'appt.notePlaceholder': 'Alleen zichtbaar voor je team',
  'appt.create': 'Afspraak maken',
  'appt.save': 'Wijzigingen opslaan',
  'appt.forceTitle': 'Toch inplannen?',
  'appt.force': 'Toch inplannen',
  'appt.alternatives': 'Wel vrij:',
  'appt.edit': 'Wijzigen',
  'appt.editTitle': 'Afspraak wijzigen',
  'appt.newTitle': 'Nieuwe afspraak',
  'appt.viewTitle': 'Afspraak',
  'appt.nextAppointment': 'Volgende afspraak',
  'appt.inWeeks': 'over {n} weken',
  'appt.noShow': 'No-show',
  'appt.cancel': 'Annuleren',
  'appt.cancelTitle': 'Afspraak annuleren',
  'appt.cancelWho': 'Wie annuleert?',
  'appt.cancelByClient': 'De klant',
  'appt.cancelBySalon': 'De salon',
  'appt.keep': 'Niet annuleren',
  'appt.restore': 'Terugzetten',
  'appt.call': 'Bellen',
  'appt.whatsapp': 'WhatsApp',
  'appt.visits': '{n} bezoeken',
  'appt.visit': '1 bezoek',
  'appt.noShows': '{n} keer niet gekomen',
  'appt.firstVisit': 'Eerste bezoek',
  'appt.history': 'Geschiedenis',
  'appt.total': 'Totaal',
  'event.created': 'Gemaakt',
  'event.moved': 'Verplaatst',
  'event.resized': 'Duur aangepast',
  'event.edited': 'Gewijzigd',
  'event.cancelled': 'Geannuleerd',
  'event.no_show': 'Als no-show gemarkeerd',
  'event.restored': 'Teruggezet',
  'event.by': 'door {name}',
  'event.online': 'Online geboekt',

  'toast.moved': 'Verplaatst naar {time}',
  'toast.movedTo': 'Verplaatst naar {name}, {time}',
  'toast.resized': 'Duurt nu tot {time}',
  'toast.noShow': 'Gemarkeerd als no-show',
  'toast.cancelled': 'Afspraak geannuleerd',
  'toast.created': 'Afspraak gemaakt',
  'toast.undo': 'Ongedaan maken',
  'toast.undone': 'Teruggezet',

  'block.who': 'Wie',
  'block.wholeSalon': 'Hele salon',
  'block.sickToday': 'Ziek melden (rest van vandaag)',
  'block.saved': 'Tijd geblokkeerd',
  'affected.title': 'Deze afspraken vallen in de geblokkeerde tijd',
  'affected.intro': 'Verzet ze naar een collega of laat ze staan. Bel of app de klant als je een nieuwe tijd wilt afspreken.',
  'affected.moveTo': 'Verzet naar {name}',
  'affected.noColleague': 'Geen collega vrij',
  'affected.leave': 'Laat staan',
  'affected.moved': 'Verzet naar {name}',
  'affected.done': 'Klaar',
};

export const calendarEn: Record<keyof typeof calendarNl, string> = {
  'cal.today': 'Today',
  'waitlist.chip': 'Waitlist · {n}',
  'waitlist.title': 'Waitlist',
  'waitlist.intro': "They'd like to come on this day. If a suitable time opens up, they get an email automatically. You can also call them yourself.",
  'waitlist.empty': 'Nobody on the waitlist for this day.',
  'waitlist.part.morning': 'Morning',
  'waitlist.part.afternoon': 'Afternoon',
  'waitlist.part.evening': 'Evening',
  'waitlist.part.any': 'Any time',
  'waitlist.waiting': 'Waiting for a time',
  'waitlist.mailed': 'Emailed at {time} that a time opened up',
  'waitlist.remove': 'Remove',
  'cal.prev': 'Previous',
  'cal.next': 'Next',
  'cal.pickDate': 'Pick a date',
  'cal.view.day': 'Day',
  'cal.view.week': 'Week',
  'cal.view.list': 'List',
  'cal.everyone': 'Everyone',
  'cal.jump': 'In … weeks',
  'cal.jumpWeeks': 'In {n} weeks',
  'cal.jumpWeek': 'In 1 week',
  'cal.newAppointment': 'New appointment',
  'cal.closed': 'Closed',
  'cal.notWorking': 'Not working',
  'cal.nobodyWorking': 'Nobody works today according to the opening and working hours.',
  'cal.noTeam': 'Add your team first under Salon → Team.',
  'cal.noLocation': 'Your salon has no location yet.',
  'cal.noClient': 'No client',
  'cal.walkIn': 'Walk-in',
  'cal.online': 'Booked online',
  'cal.newClient': 'New client',
  'cal.alert': 'Note',
  'cal.requested': 'Client chose this team member',
  'cal.listEmpty': 'No appointments on this day.',
  'cal.switchPerson': 'Switch team member',
  'cal.swipeHint': 'Swipe to change day',
  'cal.loading': 'Loading calendar…',
  'welcome.title': 'Set up your salon',
  'welcome.progress': 'Step {n} of {total}',
  'welcome.step.salon': 'Your salon',
  'welcome.step.hours': 'Opening hours',
  'welcome.step.services': 'Services',
  'welcome.step.team': 'Team',
  'welcome.hint.salon': 'Address and phone, so clients find you.',
  'welcome.hint.hours': 'When clients can book online.',
  'welcome.hint.services': 'What you do, how long it takes and what it costs.',
  'welcome.hint.team': 'Who works with you, or just you.',
  'welcome.hint.live': 'Your booking page is live',
  'welcome.later': 'About 5 minutes. You can change everything later in Salon.',
  'welcome.next': 'Continue',
  'welcome.preview.title': 'How clients see your booking page',
  'welcome.preview.label': 'Book online',
  'welcome.preview.choose': 'Choose a service',
  'welcome.preview.team': 'Book with you and',
  'welcome.preview.bar': '1 service · 45 min',
  'welcome.preview.next': 'Choose a time',
  'welcome.back': 'Back',
  'welcome.salon.title': 'Where is your salon?',
  'welcome.salon.intro': 'Clients see your address on your booking page and in the confirmation. Postcode and house number are enough.',
  'welcome.salon.phone': 'Salon phone number',
  'welcome.salon.phoneHint': 'For clients who want to call or message.',
  'welcome.hours.title': 'When are you open?',
  'welcome.hours.intro': "We filled in a common pattern. Change what's wrong; holidays and days off come later.",
  'welcome.services.title': 'What can clients book?',
  'welcome.services.intro': "A start for your kind of business. Add your own prices and remove what you don't do.",
  'welcome.services.price': 'Price',
  'welcome.services.keep': 'Keep it',
  'welcome.services.later': 'Change durations, options and processing time later under Salon → Services.',
  'welcome.team.title': 'Do you work alone?',
  'welcome.team.intro': 'Every colleague gets their own column in the calendar. Logins for colleagues can come later.',
  'welcome.team.alone': 'I work alone',
  'welcome.team.more': "There's more of us",
  'welcome.team.name': 'Colleague {n}',
  'welcome.team.add': 'Someone else',
  'welcome.team.inviteLater': 'Invite them to log in later under Salon → Team.',
  'welcome.live.title': 'Your booking page is live',
  'welcome.live.intro': 'Clients can book themselves now. Share your link or show the QR code.',
  'welcome.live.instagram': 'Tip: put the link in your Instagram bio and Google Business Profile. That’s where clients look first.',
  'welcome.live.done': 'Go to Today',
  'welcome.live.website': 'Button for your website',
  'loc.current': 'Location',
  'loc.title': 'Locations',
  'loc.intro': 'Each location has its own opening hours, team and booking link. Clients are shared.',
  'loc.add': 'Add location',
  'loc.addSecond': 'Add a second location',
  'loc.addSecondHint': 'More than one shop? Add a location with its own opening hours and team.',
  'loc.new': 'New location',
  'loc.name': 'Location name',
  'loc.nameHint': 'How clients see it, for example "Centre" or "Utrecht".',
  'loc.phone': 'Phone number',
  'loc.street': 'Street',
  'loc.houseNumber': 'House number',
  'loc.postcode': 'Postcode',
  'loc.city': 'City',
  'loc.archive': 'Remove location',
  'loc.archiveConfirm': 'This location disappears from the calendar and the booking page. Past appointments are kept.',
  'loc.hoursHint': 'Set opening hours per location under Opening hours; pick the location at the top left.',
  'loc.where': 'Works at',
  'loc.everywhere': 'All locations',
  'loc.bookingLinks': 'One link per location',
  'msg.title': 'Messages',
  'msg.intro': 'What your clients and team receive automatically. Everything is set up well by default; change what you like.',
  'msg.whatsapp': 'Messages to clients via WhatsApp',
  'msg.group.after': 'After the visit',
  'msg.review': 'Ask for a review',
  'msg.review.hint': 'One email after a completed appointment with a link to your review page. At most once every 90 days per client, never after a no-show or cancellation. Clients can opt out with one click.',
  'msg.review.url': 'Link to your review page',
  'msg.review.urlHint': 'For example your Google Business Profile: Reviews → "Ask for reviews" → copy the link.',
  'msg.review.when': 'When',
  'msg.review.after3': 'A few hours after the appointment',
  'msg.review.after24': 'The next day',
  'msg.review.needUrl': 'Paste the link to your review page first.',
  'msg.review_request': 'Review request',
  'msg.rebook': 'Rebooking reminder',
  'clients.remind': 'Send reminder',
  'clients.reminded': 'Reminder sent',
  'clients.remindHint': 'An email with a link to book again, with their usual treatment already chosen.',
  'msg.whatsapp.hint': 'Confirmations, reminders and changes go via WhatsApp to clients with a mobile number. If that fails, they get an email.',
  'msg.group.booking': 'When booking',
  'msg.group.before': 'Before the appointment',
  'msg.group.change': 'When something changes',
  'msg.group.team': 'For your team',
  'msg.confirmation': 'Confirmation',
  'msg.confirmation.hint': 'Right after booking, with a link to change or cancel.',
  'msg.reminder': 'Reminder',
  'msg.reminder.hint': 'Not sent when the appointment was booked within that time.',
  'msg.changed': 'Appointment changed',
  'msg.changed.hint': 'Two minutes after a change, so moving and undoing never sends double messages.',
  'msg.cancelled': 'Appointment cancelled',
  'msg.cancelled.hint': 'When you or the client cancels.',
  'msg.team_booked': 'New online booking',
  'msg.team_booked.hint': "To the salon's email address (Business details), otherwise to the owner.",
  'msg.team_cancelled': 'Cancelled online',
  'msg.team_cancelled.hint': 'When a client cancels themselves.',
  'msg.email': 'Email',
  'msg.timing': 'When',
  'msg.hoursBefore': '{n} hours before',
  'msg.addText': 'Add your own text',
  'msg.editText': 'Edit text',
  'msg.ownText': 'Your own text',
  'msg.ownTextPlaceholder': 'For example: Please arrive 5 minutes early. Free parking behind the salon.',
  'msg.ownTextHint': 'Shown below the standard text. Date, time and the link to change are always included.',
  'msg.preview': 'Preview',
  'msg.sendTest': 'Send me a test',
  'msg.testSent': 'Sent to {email}',
  'msg.later': "SMS and WhatsApp come later. Messages without promotion can always be sent; they don't need consent.",
  'feed.title': 'Calendar on the phone',
  'feed.titleOwn': 'Your appointments in your own calendar',
  'feed.intro': 'See the appointments in Google Calendar, Apple Calendar or Outlook. Read-only; changes come through within about 15 minutes.',
  'feed.apple': 'Apple Calendar / Outlook',
  'feed.google': 'Google Calendar',
  'feed.copy': 'Copy link',
  'feed.private': 'This link is private: anyone with it sees these appointments.',
  'feed.renew': 'Make a new link',
  'feed.renewConfirm': 'The old link stops working. Calendars using it need to be added again.',
  'sort.move': 'Move',
  'sort.hint': 'Drag to change the order (or use the arrow keys)',
  'access.title': 'App access',
  'access.intro': 'Optional: with their own login this team member sees the calendar on their own phone.',
  'access.email': 'Email address',
  'access.role': 'Role',
  'access.staffHint': 'Team member: Today, Calendar and Clients. Not the salon settings.',
  'access.managerHint': 'Manager: everything except the subscription.',
  'access.send': 'Send invitation',
  'access.invited': 'Invited: {email}',
  'access.invitedShort': 'Invited',
  'access.resend': 'Send again',
  'access.resent': 'Sent',
  'access.otherEmail': 'Other email address',
  'access.withdraw': 'Withdraw',
  'access.makeManager': 'Make manager',
  'access.makeStaff': 'Make team member',
  'access.remove': 'Remove access',
  'access.removeConfirm': "{name} won't be able to log in anymore. Their calendar and appointments stay.",
  'booking.title': 'Online booking',
  'booking.intro': 'Clients book themselves via your booking link or the button on your website. It shows in your calendar right away.',
  'booking.link': 'Your booking link',
  'booking.linkIntro': 'Share this link or QR code. Anyone can book with it straight away.',
  'booking.linkWhere': 'Put it in your Instagram bio, WhatsApp status, Google Business Profile and on your website.',
  'booking.share': 'Share your booking link',
  'booking.shareTitle': 'Book an appointment online',
  'booking.copied': 'Copied',
  'booking.copy': 'Copy',
  'booking.open': 'View as a client',
  'booking.qrAlt': 'QR code of your booking link',
  'booking.qrDownload': 'Download QR code',
  'booking.website': 'On your website',
  'booking.websiteIntro': 'Paste one of these lines into your website (WordPress, Wix or plain HTML).',
  'booking.websiteButton': 'Floating "Book now" button',
  'booking.websiteInline': 'Booking inside the page',
  'booking.rules': 'Rules',
  'booking.enabled': 'Online booking on',
  'booking.enabledHint': 'Off: your booking page shows your phone number instead of times.',
  'booking.lead': 'Minimum notice',
  'booking.leadNone': 'No minimum',
  'booking.ahead': 'How far ahead',
  'booking.step': 'Start times',
  'booking.stepHint': 'Clients can only start at these times.',
  'booking.every': 'Every {n} minutes',
  'booking.change': 'Reschedule online until',
  'booking.changeHint': 'Cancelling is always possible; inside this time it counts as late.',
  'booking.changeAlways': 'Any time',
  'booking.hoursBefore': '{n} hours before',
  'booking.hours': '{n} hours',
  'booking.days': '{n} day(s)',
  'booking.weeks': '{n} weeks',
  'booking.months': '{n} month(s)',
  'booking.year': '1 year',
  'booking.staffChoice': 'Clients choose a team member',
  'booking.staffChoiceHint': 'Off: clients only pick a time and the work is shared fairly.',
  'booking.emailRequired': 'Email address required',
  'booking.emailRequiredHint': 'Needed for the confirmation and the reminder.',
  'booking.waitlist': 'Waitlist',
  'booking.waitlistHint': 'When a day is full, clients can sign up. If an appointment falls through, they get an email straight away.',
  'today.inAgenda': 'Today in the calendar',
  'today.occupancy': 'Occupancy',
  'today.sum.one': '1 appointment still to come today.',
  'today.sum.many': '{n} appointments still to come today.',
  'today.setup.progress': '{done} of {total} done',
  'today.openClient': 'Open client',
  'tag.new': 'New',
  'tag.online': 'Online',
  'today.hero.empty': 'Nothing in the calendar today yet. Share your booking link and clients book themselves.',
  'today.hero.next': 'Next: {time} {name}, with {who}.',
  'today.hero.done': 'Today’s last appointment is done.',
  'today.hero.ofTotal': 'of {n} today',
  'today.occToday': 'Today',
  'today.occWeek': 'This week',
  'today.occClosed': 'Nobody scheduled',
  'today.newClients': 'New clients today',
  'today.returningClients': 'Regular clients today',
  'today.since': 'New since your last visit',
  'today.act.created': 'Booked online',
  'today.act.cancelled': 'Cancelled by client',
  'today.act.moved': 'Rescheduled by client',
  'today.todo': 'To do',
  'today.undelivered': 'Message didn’t reach {name}',
  'today.undeliveredHint': 'Is the email address right? Open the client and fix it.',
  'today.someone': 'a client',
  'switches.title': 'What staff can do',
  'switches.intro': 'Applies to everyone with the Staff role. Managers and the owner can always do everything.',
  'switches.allAgendas': 'See colleagues’ calendars',
  'switches.allAgendasHint': 'Off: staff only see their own column.',
  'switches.contact': 'See client phone and email',
  'switches.contactHint': 'Off: names and notes stay visible, contact details don’t.',
  'switches.editOthers': 'Change colleagues’ appointments',
  'switches.editOthersHint': 'On: staff can also move or cancel other people’s appointments.',
  'clients.export': 'Export',
  'import.button': 'Import',
  'import.title': 'Import clients',
  'import.intro': 'Export your clients as a CSV file from Salonized, Treatwell, Fresha or a spreadsheet and choose it here. Nothing happens until you press import.',
  'import.file': 'Choose a CSV file',
  'import.reading': 'Reading the file…',
  'import.columns': 'Which column is what?',
  'import.columnsHint': 'We recognised the columns. If something is off, pick the right column.',
  'import.field.firstName': 'First name',
  'import.field.lastName': 'Last name',
  'import.field.fullName': 'Full name',
  'import.field.phone': 'Mobile number',
  'import.field.email': 'Email address',
  'import.field.notes': 'Notes',
  'import.unused': '— don’t use',
  'import.summary': '{create} new clients',
  'import.existing': '{n} are already in your client list (same number or email)',
  'import.duplicate': '{n} twice in the file',
  'import.invalid': '{n} rows without a name are skipped',
  'import.existingChoice': 'Clients you already have',
  'import.skip': 'Skip',
  'import.fill': 'Fill in what’s empty (number, email, last name, notes)',
  'import.sample': 'How they come in',
  'import.problems': 'Please check in the file',
  'import.line': 'Row {n}',
  'import.reason.no_name': 'no name, skipped',
  'import.reason.phone': 'phone number unreadable, imported without number',
  'import.reason.email': 'email unreadable, imported without email',
  'import.reason.phone,email': 'phone and email unreadable',
  'import.status.create': 'new',
  'import.status.existing': 'already there',
  'import.status.duplicate': 'twice',
  'import.run': 'Import {n} clients',
  'import.done': '{created} clients added',
  'import.filled': '{n} existing clients filled in',
  'import.undo': 'Undo',
  'import.undone': '{n} clients removed again',
  'import.kept': '{n} already had an appointment and stayed',
  'import.finish': 'Done',
  'import.another': 'Choose another file',
  'clients.since': 'Client since {date}',
  'clients.lateCancels': 'Cancelled late {n} times',
  'clients.blocked': 'Blocked from online booking',
  'clients.messages': 'Messages sent',
  'clients.msgSent': 'Sent',
  'clients.msgFailed': 'Not delivered',
  'clients.blockLabel': 'Block from online booking',
  'clients.blockHint': 'This client then sees "call or message the salon" (recognised by phone and email). You can still book them in the calendar.',
  'clients.anonymise': 'Remove client data (GDPR)',
  'clients.anonymiseConfirm': "The name and contact details of {name} are removed. Appointments stay anonymously for your numbers. This can't be undone.",
  'clients.alertAdd': 'Add',
  'clients.alertNone': 'For example an allergy. Shown in the calendar (⚠), never in messages to the client.',
  'clients.alertPlaceholder': 'For example: allergic to latex',
  'clients.health': 'This is about health (allergy, medical)',
  'clients.healthHint': 'Health information may only be stored with the client’s consent.',
  'clients.consent': 'The client gave consent to store this (under 16: a parent).',
  'clients.consentGiven': 'Stored with the client’s consent.',
  'clients.withdraw': 'Consent withdrawn',
  'clients.withdrawConfirm': 'The note will be deleted.',
  'clients.name': 'Name',
  'clients.lastVisit': 'Last visit',
  'clients.nextVisit': 'Next appointment',
  'clients.visits': 'Visits',
  'clients.book': 'Book appointment',
  'clients.history': 'Appointments',
  'clients.noAppointments': 'No appointments yet.',
  'clients.notes': 'Notes',
  'clients.group.all': 'Everyone',
  'clients.group.upcoming': 'Coming back',
  'clients.group.away': 'Not seen lately',
  'clients.group.new': 'New',
  'clients.groupHint.upcoming': 'Have an appointment planned, soonest first.',
  'clients.groupHint.away': 'Not seen for more than 8 weeks and nothing planned. Time to call or message?',
  'clients.groupHint.new': 'Joined your client list in the last 30 days.',
  'clients.groupEmpty': 'Nobody in this group.',
  'clients.more': 'Load more',
  'clients.shown': '{n} of {total}',
  'clients.pickTitle': 'Pick a client',
  'clients.pickBody': 'Click a name and the client card opens here: appointments, notes and what we sent.',
  'clients.callBack': 'Give them a call?',
  'clients.callBackBody': "Haven't been in for a while and nothing planned.",
  'clients.weeksAgo': '{n} weeks ago',
  'clients.visitsN': '{n} visits',
  'clients.overview': 'Your client base',
  'clients.rebooked': 'already have their next appointment',
  'clients.nothingPlanned': 'Nothing planned yet',
  'clients.seeAll': 'See all {n}',
  'cal.side.day': 'This day',
  'cal.side.week': 'This week',
  'cal.side.appointments': 'Appointments',
  'cal.side.newClients': 'New clients',
  'cal.side.online': 'Booked online',
  'cal.side.revenue': 'Expected revenue',
  'cal.side.free': 'Still open',
  'cal.side.freeHint': 'Gaps of half an hour or more. Click one to book into it.',
  'cal.side.full': 'Full',
  'cal.side.dayOver': 'Working day over',
  'cal.side.prevMonth': 'Previous month',
  'cal.side.nextMonth': 'Next month',
  'cal.side.hours': '{h} h',
  'cal.side.hoursMinutes': '{h} h {m} min',
  'cal.side.minutes': '{m} min',
  'today.working': "Who's working today",
  'close.eyebrow': 'End of the day',
  'close.title': 'Close the day',
  'close.intro': 'In a minute: who didn’t show, who has no next appointment yet, and tomorrow.',
  'close.start': 'Close the day',
  'close.done': 'Day closed',
  'close.noShows': 'Didn’t show up?',
  'close.noShowsHint': 'Anything you don’t mark counts as done by itself.',
  'close.markNoShow': 'Didn’t show',
  'close.noVisits': 'There were no appointments today.',
  'close.withoutNext': 'No next appointment yet',
  'close.withoutNextHint': 'Plan the next one now, while it’s fresh.',
  'close.planNext': 'Plan next',
  'close.allPlanned': 'Everyone from today already has a next appointment.',
  'close.tomorrow': 'Tomorrow',
  'close.tomorrowCount': '{n} appointments, the first at {time}',
  'close.tomorrowOne': '1 appointment, at {time}',
  'close.tomorrowNone': 'Nothing in the calendar for tomorrow yet.',
  'close.alert': 'Note for {name} ({time})',
  'close.newClient': 'New: {name} ({time})',
  'close.finish': 'Done',
  'close.stillToCome': '{n} appointments still to come today.',
  'today.stat.appointments': 'Appointments',
  'today.stat.toGo': '{n} still to come',
  'today.stat.allDone': 'all done',
  'today.stat.occupancy': 'Occupancy',
  'today.stat.week': 'this week {pct}',
  'today.stat.revenue': 'Expected revenue',
  'today.stat.revenueHint': 'without no-shows',
  'today.stat.clients': 'Regular clients',
  'today.stat.new': '{n} new',
  'today.next': 'Next client',
  'today.now.label': 'In the chair now',
  'today.tomorrow': 'First tomorrow',
  'today.until': 'until {time}',
  'today.with': 'with {name}',
  'today.firstVisit': 'First visit',
  'today.openInAgenda': 'Open in calendar',
  'today.col.time': 'Time',
  'today.col.client': 'Client',
  'today.col.service': 'Service',
  'today.col.who': 'With',
  'today.col.price': 'Price',
  'today.nobody': 'Nobody is working today.',
  'today.appointments': '{n} appointments',
  'today.oneAppointment': '1 appointment',
  'today.now': 'now',
  'status.completed': 'Completed',
  'status.no_show': 'No-show',
  'status.cancelled': 'Cancelled',
  'status.requested': 'Request',
  'status.client_confirmed': 'Confirmed by client',
  'status.booked': 'Booked',

  'appt.tab.appointment': 'Appointment',
  'appt.tab.block': 'Block time',
  'appt.client': 'Client',
  'appt.searchClient': 'Search by name or phone',
  'appt.newClient': 'New client',
  'appt.firstName': 'First name',
  'appt.lastName': 'Last name',
  'appt.phone': 'Mobile number',
  'appt.emailOptional': 'Email address (for confirmation and reminder)',
  'appt.notify': 'Send confirmation to client',
  'appt.notifyHint': 'By email to {email}, with a reminder a day before.',
  'appt.notifyChange': 'Tell the client about the change',
  'appt.notifyChangeHint': 'The client gets one message with the new time after two minutes.',
  'toast.dontNotify': "Don't tell the client",
  'toast.notNotified': "The client won't get a message",
  'appt.noResults': 'No client found.',
  'appt.change': 'Change',
  'appt.removeClient': 'No client',
  'appt.services': 'Service',
  'appt.addService': '+ Another service',
  'appt.chooseService': 'Choose a service',
  'appt.noServices': "You don't have any services yet.",
  'appt.addServices': 'Add services',
  'appt.chooseVariant': 'Choose an option',
  'appt.staff': 'Team member',
  'appt.noPreference': 'No preference',
  'appt.date': 'Date',
  'appt.time': 'Time',
  'appt.now': 'Now (walk-in)',
  'appt.findFree': 'Find free time',
  'appt.freeTimes': 'Next free times',
  'appt.noFreeTimes': 'No free time found in the next three months.',
  'appt.note': 'Note',
  'appt.notePlaceholder': 'Only visible to your team',
  'appt.create': 'Create appointment',
  'appt.save': 'Save changes',
  'appt.forceTitle': 'Book anyway?',
  'appt.force': 'Book anyway',
  'appt.alternatives': 'Free instead:',
  'appt.edit': 'Edit',
  'appt.editTitle': 'Edit appointment',
  'appt.newTitle': 'New appointment',
  'appt.viewTitle': 'Appointment',
  'appt.nextAppointment': 'Next appointment',
  'appt.inWeeks': 'in {n} weeks',
  'appt.noShow': 'No-show',
  'appt.cancel': 'Cancel',
  'appt.cancelTitle': 'Cancel appointment',
  'appt.cancelWho': 'Who is cancelling?',
  'appt.cancelByClient': 'The client',
  'appt.cancelBySalon': 'The salon',
  'appt.keep': "Don't cancel",
  'appt.restore': 'Restore',
  'appt.call': 'Call',
  'appt.whatsapp': 'WhatsApp',
  'appt.visits': '{n} visits',
  'appt.visit': '1 visit',
  'appt.noShows': "Didn't show {n} times",
  'appt.firstVisit': 'First visit',
  'appt.history': 'History',
  'appt.total': 'Total',
  'event.created': 'Created',
  'event.moved': 'Moved',
  'event.resized': 'Length changed',
  'event.edited': 'Edited',
  'event.cancelled': 'Cancelled',
  'event.no_show': 'Marked as no-show',
  'event.restored': 'Restored',
  'event.by': 'by {name}',
  'event.online': 'Booked online',

  'toast.moved': 'Moved to {time}',
  'toast.movedTo': 'Moved to {name}, {time}',
  'toast.resized': 'Now ends at {time}',
  'toast.noShow': 'Marked as no-show',
  'toast.cancelled': 'Appointment cancelled',
  'toast.created': 'Appointment created',
  'toast.undo': 'Undo',
  'toast.undone': 'Restored',

  'block.who': 'Who',
  'block.wholeSalon': 'Whole salon',
  'block.sickToday': 'Report sick (rest of today)',
  'block.saved': 'Time blocked',
  'affected.title': 'These appointments fall in the blocked time',
  'affected.intro': 'Move them to a colleague or leave them. Call or message the client if you want to agree a new time.',
  'affected.moveTo': 'Move to {name}',
  'affected.noColleague': 'No colleague free',
  'affected.leave': 'Leave',
  'affected.moved': 'Moved to {name}',
  'affected.done': 'Done',
};
